export const indicadorGobRoutes = (apiBase) => ({
  indGobIndicadores: `${apiBase}/indGob/indicadores`,
  indGobConfig: `${apiBase}/indGob/configuracion`,
  indGobCatalogoFiltro: `${apiBase}/indGob/catalogo-filtro`,
});
